export default __webpack_public_path__ + "static/media/AEAE_LOGO_RVB_medium.322ddd3a.png";